'use client';

import { c as _c } from "react/compiler-runtime";
import { debounce } from 'lodash';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import { Stamp } from '@src/components/TopNavV5/Stamp';
import { useTopNavV5 } from '@src/components/TopNavV5/TopNavV5Context';
import type { TopNavV5MenuItem } from '@src/components/TopNavV5/TopNavV5Props';
import { cn } from '@src/utils/tailwind';
export const TopNavV5DesktopMiniMenu = props => {
  const $ = _c(34);
  const {
    item,
    componentKey,
    index,
    itemClasses
  } = props;
  const {
    setExpanded,
    topNavDesktopTopOffset
  } = useTopNavV5();
  const [activeIndex, setActiveIndex] = useState(null);
  const triggerRef = useRef(null);
  const [triggerX, setTriggerX] = useState(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleResize = () => {
        if (triggerRef.current) {
          setTriggerX(triggerRef.current.getBoundingClientRect().x + triggerRef.current.offsetWidth / 2);
        }
      };
      const debouncedHandleResize = debounce(handleResize, 200);
      handleResize();
      window.addEventListener("resize", debouncedHandleResize);
      return () => {
        window.removeEventListener("resize", debouncedHandleResize);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("group relative flex h-full items-center transition-all hover:text-bodi-white");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== index || $[4] !== setExpanded) {
    t3 = () => {
      setActiveIndex(index);
      setExpanded(false);
    };
    $[3] = index;
    $[4] = setExpanded;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setActiveIndex(null);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== itemClasses) {
    t5 = cn(itemClasses, "relative flex items-center gap-2 font-normal");
    $[7] = itemClasses;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== item.stamp) {
    t6 = <Stamp text={item.stamp} />;
    $[9] = item.stamp;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute bottom-0 left-0 z-max h-[3px] w-full bg-bodi-accent-bright-500 opacity-0 transition-all duration-200 group-hover:opacity-100" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== item.title || $[13] !== t5 || $[14] !== t6) {
    t8 = <div ref={triggerRef} className={t5}>{item.title}{t6}{t7}</div>;
    $[12] = item.title;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = activeIndex === index;
  let t10;
  if ($[16] !== t9) {
    t10 = cn("fixed z-30 -translate-x-1/2 bg-bodi-black-text bg-linear-to-t from-white/10 to-white/0 py-5 whitespace-nowrap transition-all duration-200", "invisible hidden", {
      "visible block": t9
    });
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== topNavDesktopTopOffset || $[19] !== triggerX) {
    t11 = {
      left: triggerX,
      top: topNavDesktopTopOffset
    };
    $[18] = topNavDesktopTopOffset;
    $[19] = triggerX;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== item.miniMenuItems) {
    t12 = item.miniMenuItems?.map(_temp);
    $[21] = item.miniMenuItems;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12) {
    t13 = <ul>{t12}</ul>;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t13) {
    t14 = <div className={t10} style={t11}>{t13}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== componentKey || $[30] !== t14 || $[31] !== t3 || $[32] !== t8) {
    t15 = <div key={componentKey} className={t2} onMouseEnter={t3} onMouseLeave={t4}>{t8}{t14}</div>;
    $[29] = componentKey;
    $[30] = t14;
    $[31] = t3;
    $[32] = t8;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
function _temp(subItem, index_0) {
  return <li className="flex flex-col px-6 py-2" key={`${subItem.title}-${index_0}`}><div className="flex items-center"><Link href={subItem.href ?? ""} className="text-body-base whitespace-nowrap text-bodi-gray-butters hover:text-bodi-white hover:underline" dangerouslySetInnerHTML={{
        __html: subItem.title ?? ""
      }} /></div></li>;
}